<template>
  <div class="empty">
    <img src="@/assets/empty.svg" alt="Empty!">
    <h2>
      <slot name="title">
        Nic tutaj nie ma
      </slot>
    </h2>
    <p>
      <slot name="description">
        Dodaj pierwsze dokumenty klikając plusa
      </slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style lang="scss" scoped>
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: calc(80vh - 100px);
    text-align: center;
    padding: 0 8px;
    box-sizing: border-box;
    padding-bottom: 32px;

    img {
      width: 100%;
      max-width: 400px;
    }

    h2 {
      color: #888;
      font-weight: 300;
      font-size: 1.4em;
    }

    p {
      margin: 0;
      color: #021234;
    }
  }
</style>